import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import usePostSetPlaidCredentials from '../../../../hooks/useApi/usePostSetPlaidCredentials';

import UpdatePlaidForm from './UpdatePlaidForm';
import UpdatePlaidReview from './UpdatePlaidReview';
import UpdatePlaidContext, { UpdatePlaidCtx } from './Dialogue/UpdatePlaidContext';
import UpdatePlaidDialogue from './Dialogue/UpdatePlaidDialogue';
import { UpdatePlaidDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useClientData } from '../../../../providers/ClientData.provider';

type FC = FunctionComponent;

const UpdatePlaidContainer: FC = () => {
  const history = useHistory();
  const [UpdateError, setUpdateError] = useState('');
  const [showUpdateErrorAlert, setShowUpdateErrorAlert] = useState(false);
  const [showUpdateSuccessAlert, setShowUpdateSuccessAlert] = useState(false);
  const [shouldUpdatePlaid, setShouldUpdatePlaid] = useState(false);
  const [setPlaidCredentialsResponse, setPlaidCredentials] = usePostSetPlaidCredentials({});

  const [review, setReview] = useState(false);
  const { response } = useClientData();
  const [PlaidRequest, setPlaidRequest] = useState<vp.SetPlaidCredentialsRequest>({
    PlaidClientID: '',
    PlaidSecretKey: '',
    PlaidUrl: '',
    PortalUser: response.LoginUserName,
  });

  const UpdatePlaid: UpdatePlaidCtx = {
    showUpdateSuccessAlert,
    showUpdateErrorAlert,
    UpdateError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<UpdatePlaidDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: UpdatePlaidDialogueHandler = {
        update: {
          success: {
            default: () => {
              setShowUpdateSuccessAlert(false);
              history.push('/integrations/Plaid');
            },
          },
          error: {
            default: () => {
              setShowUpdateErrorAlert(false);
              setUpdateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onReview: (values: vp.SetPlaidCredentialsRequest) => {
      setReview(true);
      setPlaidRequest(values);
    },
    onUpdate: (values: vp.SetPlaidCredentialsRequest) => {
      setShouldUpdatePlaid(true);

      setPlaidCredentials(values);
    },
    onBack: () => {
      setReview(false);
    },
  };

  useEffect(() => {
    if (shouldUpdatePlaid) {
      setShouldUpdatePlaid(false);

      if (setPlaidCredentialsResponse?.Success === true) {
        setShowUpdateSuccessAlert(true);
      } else {
        setUpdateError(setPlaidCredentialsResponse?.ErrorMessage || '');
        setShowUpdateErrorAlert(true);
      }
    }
  }, [setPlaidCredentialsResponse]);

  return (
    <UpdatePlaidContext.Provider value={UpdatePlaid}>
      {!review && <UpdatePlaidForm defaultValues={PlaidRequest} onSubmit={handlers.onReview} />}
      {review && (
        <UpdatePlaidReview defaultValues={PlaidRequest} onSubmit={handlers.onUpdate} onBack={handlers.onBack} />
      )}
      <UpdatePlaidDialogue handleDialogue={handlers.handleDialogue} />
    </UpdatePlaidContext.Provider>
  );
};

export default UpdatePlaidContainer;
